var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.892,
    height: 43.892,
    viewBox: "0 0 43.892 43.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.605,3.772H35.519v-1.2a2.572,2.572,0,0,0-5.144,0v1.2h-14.4v-1.2a2.572,2.572,0,1,0-5.144,0V3.8a.855.855,0,0,0-.229-.032H7.186A4.291,4.291,0,0,0,2.9,8.058v14.6a.857.857,0,0,0,1.715,0V12.6H35.519a.857.857,0,1,0,0-1.715H4.614V8.058A2.575,2.575,0,0,1,7.186,5.486H10.6a.859.859,0,0,0,.229-.032v1.1a2.572,2.572,0,0,0,5.144,0V5.486h14.4V6.558a2.572,2.572,0,0,0,5.144,0V5.486h4.086a2.575,2.575,0,0,1,2.572,2.572V40.634a1.544,1.544,0,1,1-3.087,0V38.416a.857.857,0,0,0-.857-.857H28.261a.857.857,0,1,0,0,1.715h9.114v1.36a3.238,3.238,0,0,0,.39,1.544H3.258a1.545,1.545,0,0,1-1.543-1.543V39.273H20.9a.857.857,0,1,0,0-1.715H12.337a7.03,7.03,0,1,0-9.161,0H.857A.857.857,0,0,0,0,38.416v2.218a3.261,3.261,0,0,0,3.258,3.258H40.633a3.262,3.262,0,0,0,3.258-3.258V8.058A4.291,4.291,0,0,0,39.605,3.772ZM14.259,6.558a.857.857,0,1,1-1.715,0V2.572a.857.857,0,1,1,1.715,0Zm19.545,0a.857.857,0,1,1-1.715,0V2.572a.857.857,0,1,1,1.715,0ZM2.441,32.233a5.315,5.315,0,1,1,5.315,5.315A5.321,5.321,0,0,1,2.441,32.233Z",
    transform: "translate(0)",
    fill: "#f05a29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.683 10.887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.7,127.251a.856.856,0,1,0,.251.606A.863.863,0,0,0,452.7,127.251Z",
    transform: "translate(-451.24 -127)",
    fill: "#f05a29"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.139 37.559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.043,438.38a.858.858,0,1,0,.251.606A.863.863,0,0,0,283.043,438.38Z",
    transform: "translate(-281.58 -438.13)",
    fill: "#f05a29"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.137 26.061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.5,304a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,191.5,304Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,191.5,308.8Z",
    transform: "translate(-188.245 -304)",
    fill: "#f05a29"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.138 26.061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.836,304a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,284.836,304Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,284.836,308.8Z",
    transform: "translate(-281.578 -304)",
    fill: "#f05a29"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.14 26.061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.17,304a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,378.17,304Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,378.17,308.8Z",
    transform: "translate(-374.912 -304)",
    fill: "#f05a29"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.136 17.145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.17,200a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,98.17,200Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,98.17,204.8Z",
    transform: "translate(-94.912 -200)",
    fill: "#f05a29"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.138 17.145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.836,200a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,284.836,200Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,284.836,204.8Z",
    transform: "translate(-281.578 -200)",
    fill: "#f05a29"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.14 17.145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.17,200a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,378.17,200Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,378.17,204.8Z",
    transform: "translate(-374.912 -200)",
    fill: "#f05a29"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.137 17.145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.5,200a3.258,3.258,0,1,0,3.258,3.258A3.261,3.261,0,0,0,191.5,200Zm0,4.8a1.543,1.543,0,1,1,1.543-1.543A1.545,1.545,0,0,1,191.5,204.8Z",
    transform: "translate(-188.245 -200)",
    fill: "#f05a29"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.389 29.893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.616,348.951a.857.857,0,0,0-1.212,0l-2.792,2.792-.954-.954A.857.857,0,0,0,51.445,352l1.56,1.56a.857.857,0,0,0,1.212,0l3.4-3.4A.857.857,0,0,0,57.616,348.951Z",
    transform: "translate(-51.194 -348.7)",
    fill: "#f05a29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.4112665fc58999be2843aeee3ee50ad5.svg";
export { ForwardRef as ReactComponent };